import { Jurisdiction, schemes, zSchema } from "@zeal/common";

export const getJurisdictionLaborPostersRequestSchema = zSchema.object({
  jurisdiction: zSchema.nativeEnum(Jurisdiction),
});
export type TGetJurisdictionLaborPostersRequestSchema = zSchema.infer<
  typeof getJurisdictionLaborPostersRequestSchema
>;

export const getJurisdictionLaborPostersResponseSchema = zSchema.array(
  zSchema.object({
    labor_poster_id: schemes.uuid(),
    title: zSchema.string(),
    is_mandatory: zSchema.boolean(),
  })
);
export type TGetJurisdictionLaborPostersResponseSchema = zSchema.infer<
  typeof getJurisdictionLaborPostersResponseSchema
>;
